import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const CHARACTERS_TCA = [
  {
    title: "NETWORK\n DESIGNER",
    subtitle: "",
    items: [
      "Vendor-agnostic\n management of network\n function packages",
      "Day 0 configuration of \nCloud Infrastructure for NF \n workloads",
      "Single-Touch deployment\n and orchestration of \nnetwork services",
    ],
    image: "ILO/characters/character_1.png",
    gif: "ILO/characters/character_1.gif",
    gifStyle: {
      position: "relative",
      width: "260px",
      height: "349px",
      overflow: "hidden",
    },
    next: {
      label: "PROVIDER DEMO",
      onClick: () => {
        setPreviousPage("ILO_305");
        setCurrentPage("ILO_306");
      },
      endIcon: "play",
    },
  },
  {
    title: "NETWORK \nOPERATION TEAM",
    subtitle: "",
    items: [
      "On-demand scaling of\n network services to meet\n growing demands",
      "Automated Day 2/N\n configuration of network\n functions",
      "Auto-healing of network\n faults through ML based \nclosed-loop automation",
    ],
    image: "ILO/characters/character_2.png",
    gif: "ILO/characters/character_2.gif",
    gifStyle: {
      position: "relative",
      width: "260px",
      height: "349px",
      overflow: "hidden",
    },
    next: {
      label: "ENTERPRISE DEMO",
      onClick: () => {
        setPreviousPage("ILO_305");
        setCurrentPage("ILO_312");
      },
      endIcon: "play",
    },
  },
];

export const DATA_CHARACTERS_TCA = {
  title: "Challenges solved",
  bgImage: "ILO/TCA/TCA_Intro_05.png",
  characters: CHARACTERS_TCA,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_304"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  actions: [
    {
      label: "Network DESIGNER DEMO",
      onClick: () => {
        setPreviousPage("ILO_305");
        setCurrentPage("ILO_306");
      },
      endIcon: "arrow-right",
    },
    {
      label: "Network operation team DEMO",
      onClick: () => {
        setPreviousPage("ILO_305");
        setCurrentPage("ILO_312");
      },
      endIcon: "arrow-right",
    },
  ],
};
